<template>
    <main>
        <div class="banner">
            <div class="w-50 image">
                <img src="/images/healthcare2.jpg" alt="" data-aos="zoom-out-up">
            </div>
            <div class="w-50 content">
                <p class="subtitle" data-aos="fade-up" data-aos-delay="100"><strong>
                        <span v-if="selectedLang() == 'en'">WHAT WE DO</span>
                        <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">ماذا نفعل</bdo></span>
                        <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">چی دەکەین </bdo></span>
                    </strong></p>
                <p class="title"> <span v-if="selectedLang() == 'en'" data-aos="fade-up" data-aos-delay="200">Kurdos MedTech</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">التكنولوجيا الطبية</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">تەکنەلۆژیای پزیشکی</bdo></span>
                </p>
                <p class="text text1" data-aos="fade-up" data-aos-delay="300">
                    <span v-if="selectedLang() == 'en'">Kurdos MedTec focuses on sales & service of Medical Equipment,
                        Devices and Consumables
                        Disposables for Hospitals and Laboratories. Our product range include Laboratory Equipment &
                        Consumables for <strong> Biochemistry,Cytology,Hematology,Microbiology,Serology &
                            Transplantation.</strong></span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">تُركز شركة كردوس ميديكال تي على بيع وصيانة
                            المعدات والأجهزة الطبية والمواد الاستهلاكية للاستخدام مرة واحدة للمستشفيات والمختبرات. تشمل
                            منتجاتنا معدات ومواد مختبرية لمجالات الكيمياء الحيوية، وعلم الخلايا، وأمراض الدم، والأحياء
                            الدقيقة، وعلم الأمصال، وزراعة الأعضاء.</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">گرنگی بە فرۆشتن و خزمەتگوزاری ئامێری پزیشکی
                            ,ئامێر و کەلوپەلی بەکارهێنراوی یەکجار بەکارهێنراو بۆ نەخۆشخانە و تاقیگەکان دەدات.
                            بەرهەمەکانمان بریتین لە ئامێری تاقیگە و کەلوپەلی بەکارهێنراو بۆ بایۆکیمیا، خانەزانیی، خوێن،
                            مایکرۆبایۆلۆجی، سیرۆلۆژی و چاندن.</bdo></span>

                </p>
                <p class="text text2" data-aos="fade-up" data-aos-delay="400">
                    <span v-if="selectedLang() == 'en'">We also provide <strong> sales & service of medical equipment
                        </strong> which include Patient
                        Monitor, Central
                        Monitoring System, ECG Machines, Fetal and Maternal Monitors, Vital Signs Monitors, Etco2
                        Monitor, Defibrillator, Pulse Oximeter, Infusion Pump, Syringe Pump, Feeding Pump, Holter
                        System,
                        Ultrasonic Pocket Doppler, Blood & Infusion Warmer, Ventilators, Otoscope, Ophthalmoscope,
                        laryngoscope and Consumables</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">نوفر أيضًا خدمات بيع وصيانة المعدات الطبية، بما
                            في ذلك أجهزة مراقبة المرضى، ونظام المراقبة المركزية، وأجهزة تخطيط القلب، وأجهزة مراقبة
                            الأجنة والأمهات، وأجهزة مراقبة العلامات الحيوية، وجهاز مراقبة ثاني أكسيد الكربون، وجهاز مزيل
                            الرجفان، ومقياس التأكسج النبضي، ومضخة التسريب، ومضخة الحقن، ومضخة التغذية، ونظام هولتر،
                            وجهاز دوبلر الجيب بالموجات فوق الصوتية، وسخان الدم والتسريب، وأجهزة التنفس الصناعي، ومنظار
                            الأذن، ومنظار العين، ومنظار الحنجرة، واللوازم الطبية.</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">هەروەها ئێمە فرۆشتن و خزمەتگوزاری ئامێری پزیشکی
                            پێشکەش دەکەین
                            کە نەخۆش لەخۆدەگرێت
                            مۆنیتەر، ناوەندی
                            سیستەمی چاودێری، ئامێری ECG، چاودێری کۆرپەلە و دایک، چاودێری نیشانە گرنگەکان، Etco2
                            مۆنیتەر، دیفیبریلەتەر، ئۆکسیمێتری پەستان، پەمپە ئینفیوژن، پەمپە سرنج، پەمپە خۆراکدان، هۆڵتەر
                            سیستەم،
                            دۆپلەری گیرفانی سۆنەر، گەرمکەرەوەی خوێن و ئینفیوژن، هەواگۆڕکێ، ئۆتۆسکۆپ، چاو،
                            لارینگۆسکۆپ و شتومەکی بەکارهێنراو</bdo></span>


                </p>
            </div>
        </div>
        <div class="products">
            <div class="product" v-for="i in products" :key="i" data-aos="fade-up">
                <div class="product-image">
                    <img :src="i.image" alt="">
                </div>
                <div class="content2">
                    <p>{{ i.title }}</p>
                </div>
            </div>
        </div>
    </main>
</template>

<script setup>
import { ref } from 'vue'
import { selectedLang } from '../../utils/selected_lang';

const products = ref([
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-036.png',
        title: 'Twelve-channel ECG',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-038.png',
        title: 'Patient Monitor',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-040.png',
        title: 'Central Monitoring System',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-042.png',
        title: 'Patient Monitor - II',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-044.png',
        title: 'Defibrillator Monitor ',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-046.png',
        title: 'Patient Monitor',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-050.png',
        title: 'Fetal Monitor',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-052.png',
        title: 'Vital Signs Monitor',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-054.png',
        title: 'Vital Signs Monitor',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-056.png',
        title: 'Infusion Pump',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-058.png',
        title: 'Syringe Pump',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-060.png',
        title: 'Feeding Pump ',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-064.png',
        title: 'Holter System ',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-066.png',
        title: 'Pulse Oximeter ',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-068.png',
        title: 'Ultrasonic Pocket Doppler',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-070.png',
        title: 'EtcO2 Monitor',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-072.png',
        title: 'Pulse Oximeter - II',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-074.png',
        title: 'Blood & Infusion Warmer',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-078.png',
        title: 'Otoscope',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-080.png',
        title: 'Ophthalmoscope',
    },

    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-082.png',
        title: 'ENT Diagnostic Set'
    },

    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-084.png',
        title: 'Laryngoscopes Macintosh & Miller',
    },

    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-086.png',
        title: 'Air-Compressing Nebulizer',
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-088.png',
        title: 'Electronic Blood Pressure Monitor'
    },
    {
        image: '/healthcare_images/medtec/KURDOS-HEALTHCARE-TAB (1).pdf-image-090.png',
        title: 'Emergency Transport Ventilator',
    },


])

</script>

<style scoped>
* {
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif !important;
}


.dark main {
    background: #131313;
    color: white !important;
}
.dark .banner{
    background: #323232;
}
.dark .content p, .dark .title{
    color: white;
}
.dark .product{
    background: #323232;
}
.dark .content2 p{
    color: #fff !important;
}


main {
    /* color: #073762 !important;  */
    background: #F6F8FB;
    padding: 50px 100px;

}
.title{
    line-height: 2.1rem !important;
}

.banner {
    display: flex;
    background: white;
    padding: 20px;
    border-radius: 15px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    margin-bottom: 56px;
}

.w-50 {
    width: 50%;
}

.image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 15px;
}

.content {
    padding: 50px;
}

.title,
.subtitle {
    text-transform: uppercase;
}

.subtitle {
    color: #E43D34 !important;
    font-size: 18px !important;
}

.title {
    color: #073762;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 20px;
}

.content p {
    color: #073762;

}

.products {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
}

.product {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: transform 0.2s ease;
    padding: 10px;
}

.product:hover {
    transform: translateY(-5px);
}

.product-image {
    width: 100%;
    height: 220px;
    overflow: hidden;
    border-radius: 10px;
}

.product-image img {
    height: 100%;
    width: 100%;
    object-fit: cover;
}

.content2 {
    padding: 1rem;
    text-align: center;
}

.content2 p {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 500;
    color: #073762 !important;
}


@media (max-width: 768px) {
    main {
        padding: 20px;
    }

    .banner {
        flex-direction: column;
    }

    .w-50 {
        width: 100%;
    }

    .content {
        padding: 20px;
    }
}
</style>